import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";

const LocationFinderOption = ({
    imageURL,
    alertText,
    detailsText,
    heading,
    onClickHandler,
    geoError = ""
}) => {
    return (

        <div styleName={`styles.optionWrapper ${geoError ? "styles.disable" : ""}`} onClick={onClickHandler}>
            <div styleName="styles.imageWrapper">
                <img src={imageURL}/>
            </div>
            <div styleName="styles.block">
                <div styleName="styles.heading" className={"locationIcon"}>{heading}</div>
                {!alertText ? <p styleName="styles.detailText">{detailsText}</p>
                    : <span>{alertText}</span>
                }
            </div>
        </div>

    );
};

LocationFinderOption.propTypes = {
    imageURL: PropTypes.string,
    alertText: PropTypes.string,
    detailsText: PropTypes.string,
    heading: PropTypes.string,
    onClickHandler: PropTypes.func,
    geoError: PropTypes.string
};

export default LocationFinderOption;
